import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { parse, format } from "date-fns";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(input: string): string {
  try {
    if (input === "") return input; // Check if the string is empty
    // Parse the input string into a Date object
    const parsedDate = parse(input.split(" ")[0], "dd-MM-yyyy", new Date());

    // Format the Date object into the desired format
    const formattedDate = format(parsedDate, "dd MMMM yy");

    return formattedDate;
  } catch (error) {
    console.log(error);
    return input;
  }
}

export function formatFullDate(input: string): string {
  //input e.g. 2023-04-25T11:52:41.000000Z
  try {
    if (input === "") return input; // Check if the string is empty
    // Parse the input string into a Date object
    const formattedDate = format(new Date(input), "MMMM yyyy");
    return formattedDate;
  } catch (error) {
    console.log(error);
    return input;
  }
}
